module.exports = __webpack_public_path__ + "static/media/am_view-requested-account-holds.f7dab1b9.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_view-requested-account-holds.md
// module id = 1091
// module chunks = 0